import { Button, Grid, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseBox from "../../base/BaseBox/baseBox";
import MailForm from "../../form/MailForm";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import DateField from "../../field/DateField/DateField";
import { useForm } from "../../../hooks/useForm";
import AutocompleteField from "../../field/AutocompleteField";
import { APPROVED_BY_DC_ROW_COLOR, HIGHLIGHTED_ITEM, LIGHT_GRAY_ITEM, SELECTED_ROW_COLOR } from "../../../helpers/constants";
import BoxWithTypography from "../../box/BoxWithTypography";

export default function AnswerRow({ answerData, scores, readOnly, onEditAnswer, isInvalid }) {
    const { t } = useTranslation();
    const [isTextFieldChanged, setTextFieldChanged] = useState()
    const [dataChanged, setDataChanged] = useState()

    const {
        formValue,
        setFormValue,
        onChangeWithCallback,
        onChangeAutocompleteFieldWithObjectOptionsAndCallback
    } = useForm(answerData)

    useEffect(() => {
        setFormValue(answerData)
    }, [answerData])


    const onChangeTextFieldLocal = useCallback((name, value) => {
        setTextFieldChanged(true)
        let tempData = {}
        tempData[name] = value
        setDataChanged(tempData)
    }, [])



    const onChangeAutocompleteLocal = useCallback((name, value) => {
        let tempData = {}
        tempData[name] = value
        onEditAnswer(answerData.id, tempData)
    }, [answerData])

    const onBlurLocal = useCallback(() => {
        if (isTextFieldChanged) {
            onEditAnswer(answerData.id, dataChanged)
        }
    }, [answerData, dataChanged, isTextFieldChanged])


    const getQuestionRow = () => {
        return (
            <>
                <Grid item sm={7} >
                    <TextFieldFormControl
                        label={t('form.answer_form.hrquestion_name')}
                        value={formValue?.hrquestion_name}
                        readOnly
                        multiline
                        rows={2}
                        inputStyle={{
                            "-webkit-text-fill-color": "black",
                        }}
                        resize="vertical"
                    />
                </Grid>
                <Grid item sm={2.5} >
                    <AutocompleteField
                        name="hrscore"
                        label={t('form.answer_form.hrscore')}
                        value={formValue?.hrscore}
                        options={scores}
                        optionLabelKey={"hrscore_name"}
                        isObjectOption={true}
                        disableClearable={true}
                        multiple={false}
                        onChange={onChangeAutocompleteFieldWithObjectOptionsAndCallback(onChangeAutocompleteLocal)}
                        readOnly={readOnly}
                        style={{ backgroundColor: HIGHLIGHTED_ITEM }}
                        error={isInvalid}
                        helperText={isInvalid && t('form.answer_form.answer_not_filled')}
                    />
                </Grid>

                <Grid item sm={2.5} >
                    <TextFieldFormControl
                        name="hranswer_note"
                        label={t('form.answer_form.hranswer_note')}
                        value={formValue?.hranswer_note}
                        readOnly={readOnly}
                        onChange={onChangeWithCallback(onChangeTextFieldLocal)}
                        onBlur={onBlurLocal}
                        multiline
                        rows={1}
                        resize="vertical"
                    />
                </Grid>
            </>
        )
    }
    // style={{ backgroundColor: LIGHT_GRAY_ITEM}}

    return (
        <Grid container spacing={2}>
            {!formValue?.category_is_hidden ?

                <Grid item xs={12}>
                    <BoxWithTypography
                        label={formValue?.category_name}
                    >

                        <Grid container spacing={2}>
                            {getQuestionRow()}
                        </Grid>
                    </BoxWithTypography>
                </Grid>
                :
                getQuestionRow()
            }
        </Grid>
    );
}

AnswerRow.propTypes = {
    answerData: PropTypes.object,
    readOnly: PropTypes.bool,
    onEditAnswer: PropTypes.func,
    isInvalid: PropTypes.bool
}


AnswerRow.defaultProps = {
}
